<template>
    <pendo-router-link
        class="pendo-logo"
        :to="{ name: 'Home' }">
        <div
            v-if="isWhiteLabel"
            class="product-name">
            <img
                v-if="productNameLogoUrl"
                :src="productNameLogoUrl"
                class="product-name--logo"
                :alt="`${productName} Logo`">
            <pendo-divider
                v-if="productName"
                direction="vertical"
                width="2.5rem" />
            <div
                v-if="productName"
                class="product-name--label">
                {{ productName }}
            </div>
        </div>
        <img
            v-else-if="useDarkLogo"
            src="@img/dark-mode-logo.svg"
            width="100"
            height="auto"
            alt="Pendo Logo">
        <img
            v-else
            src="@img/pdf-logo.png"
            width="100"
            height="auto"
            alt="Pendo Logo">
    </pendo-router-link>
</template>

<script>
import { mapState } from 'vuex';
import { PendoDivider } from '@pendo/components-vue3';
import PendoRouterLink from '@/vue-router/pendo-router-link.vue';
import get from 'lodash/get';

export default {
    name: 'Logo',
    components: {
        PendoRouterLink,
        PendoDivider,
    },
    props: {
        useDarkLogo: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        ...mapState({
            unauthenticatedTrainingAttributes: (state) => state.auth.unauthenticatedTrainingAttributes,
        }),
        productNameLogoUrl () {
            return get(this.unauthenticatedTrainingAttributes, 'whiteLabelSettings.logoUrl');
        },
        productName () {
            return get(this.unauthenticatedTrainingAttributes, 'productName');
        },
        isWhiteLabel () {
            return !!get(this.unauthenticatedTrainingAttributes, 'whiteLabelSettings');
        },
    },
};
</script>

<style scoped lang="less">
.pendo-logo {
    border-radius: 5px;

    &:focus-visible {
        outline: 2px solid var(--palette-gray-90);
        outline-offset: 4px;
    }

    .product-name {
        z-index: 1;
        display: flex;
        align-items: center;

        .product-name--logo {
            height: 25px;
            vertical-align: middle;
        }

        .product-name--label {
            color: var(--palette-gray-70);
            font-size: 15px;
            font-weight: 600;
            line-height: 2rem;
        }
    }
}
</style>
